import * as yup from 'yup';
import { imageValidation, enabledValidation, regexColor, validateTimeZoneIdentifiers } from 'utils/yup';
import { TFunction } from 'i18next';

export const CreateForm = (t: TFunction): any =>
  yup.object().shape({
    name: yup
      .string()
      .required(t('schema-venue-form-name-required'))
      .min(3, t('schema-venue-form-name-min'))
      .max(191, t('schema-venue-form-name-max')),
    code: yup
      .string()
      .required(t('schema-venue-form-code-required'))
      .min(3, t('schema-venue-form-code-min'))
      .max(32, t('schema-venue-form-code-max')),
    appColor: yup.string().matches(regexColor, t('schema-venue-form-appColor-matches')),
    appSecondaryColor: yup.string().matches(regexColor, t('schema-venue-form-appColor-matches')),
    wallioUrl: yup
      .string()
      .min(3, t('schema-venue-form-wallio-url-min'))
      .max(191, t('schema-venue-form-wallio-url-max'))
      .url(t('schema-venue-form-wallio-url')),
    wallioTitle: yup.string(),
    logo: imageValidation(t('schema-venue-form-logo'), true, t),
    map: imageValidation(t('schema-venue-form-map'), false, t),
    useDifferentIconSet: enabledValidation(t),
    logoForTinting: yup.mixed().when('useDifferentIconSet', {
      is: true,
      then: imageValidation(t('schema-venue-form-logoForTinting'), true, t),
    }),
    venueMap: imageValidation(t('schema-venue-form-venueMap'), false, t),
    banner: imageValidation('Banner', false, t),
    language: yup.string().required(t('schema-venue-form-language-required')),
    billingRange: yup
      .number()
      .integer(t('schema-venue-form-integer-billing-range-integer'))
      .required(t('schema-venue-form-integer-billing-range-required')),
    timeZoneIdentifier: validateTimeZoneIdentifiers(t),
    apps: yup.array().of(yup.string()).min(1, t('schema-venue-form-apps-are-required')),
  });

export const EditForm = (t: TFunction, hasBettingSection: boolean, requiresTomorrowPassword: boolean): any =>
  yup.object().shape({
    name: yup
      .string()
      .required(t('schema-venue-form-name-required'))
      .min(3, t('schema-venue-form-name-min'))
      .max(191, t('schema-venue-form-name-max')),
    code: yup
      .string()
      .required(t('schema-venue-form-code-required'))
      .min(3, t('schema-venue-form-code-min'))
      .max(32, t('schema-venue-form-code-max')),
    wallioUrl: yup
      .string()
      .min(3, t('schema-venue-form-wallio-url-min'))
      .max(191, t('schema-venue-form-wallio-url-max'))
      .url(t('schema-venue-form-wallio-url')),
    wallioTitle: yup.string(),
    bettingTitle: hasBettingSection
      ? yup.string().required(t('schema-venue-form-betting-title-required'))
      : yup.string(),
    bettingUrl: hasBettingSection
      ? yup.string().url(t('schema-venue-form-betting-url')).required(t('schema-venue-form-betting-url-required'))
      : yup.string(),
    logo: imageValidation(t('schema-venue-form-logo'), true, t),
    map: imageValidation(t('schema-venue-form-map'), false, t),
    commerces: yup.array().of(yup.string()),
    venueEditor: yup.string().required(t('schema-venue-form-venue-editor-required')),
    enabled: enabledValidation(t),
    useDifferentIconSet: enabledValidation(t),
    venueMap: imageValidation(t('schema-venue-form-venueMap'), false, t),
    downloadBanner: imageValidation(t('schema-venue-form-downloadBanner'), false, t),
    banner: imageValidation('Banner', false, t),
    cloverMiniBackgroundImage: imageValidation(t('schema-venue-form-cloverMiniBackground'), false, t),
    cloverMiniLowerBanner: imageValidation(t('schema-venue-form-cloverMiniLowerBanner'), false, t),
    cloverFlexBackgroundImage: imageValidation(t('schema-venue-form-cloverFlexBackground'), false, t),
    cloverFlexLowerBanner: imageValidation(t('schema-venue-form-cloverFlexLowerBanner'), false, t),
    language: yup.string().required(t('schema-venue-form-language-required')),
    billingRange: yup
      .number()
      .integer(t('schema-venue-form-integer-billing-range-integer'))
      .required(t('schema-venue-form-integer-billing-range-required')),
    entityIdentificator: yup.number().integer(t('schema-venue-form-entity-identificator-integer')),
    sections: yup.array().of(yup.string()).min(1, t('schema-venue-form-sections-are-required')),
    timeZoneIdentifier: validateTimeZoneIdentifiers(t),
    usesTomorrowPartnerBenefits: enabledValidation(t),
    tomorrowAppUserName: yup.mixed().when('usesTomorrowPartnerBenefits', {
      is: true,
      then: yup.string().required(t('schema-venue-form-tomorrowAppUserName-required')),
    }),
    ...(requiresTomorrowPassword && {
      tomorrowAppPassword: yup.mixed().when('usesTomorrowPartnerBenefits', {
        is: true,
        then: yup.string().required(t('schema-venue-form-tomorrowAppPassword-required')),
      }),
    }),
    tomorrowAppAcronym: yup.mixed().when('usesTomorrowPartnerBenefits', {
      is: true,
      then: yup.string().required(t('schema-venue-form-tomorrowAppAcronym-required')),
    }),
    tomorrowPartnerMainDocumentType: yup.mixed().when('usesTomorrowPartnerBenefits', {
      is: true,
      then: yup.string().required(t('schema-venue-form-tomorrowPartnerMainDocumentType-required')),
    }),
    apps: yup.array().of(yup.string()).min(1, t('schema-venue-form-apps-are-required')),
  });
